export const emailRequiredMsg = 'Email address is required';

export const emailInvalidMsg = 'Enter a valid email address';

export const passwordRequiredMsg = 'Password is required';

export const emailExistsMsg =
    'You signed up in-store and need to create a password. Check your email for a link to finish setting up your account.';

export const CHECKOUT_PAGE = '/checkout';

export const CART_PAGE = '/cart';

export const TREATS_REWARDS_PAGE = '/treats-rewards';

export const TREATS_REWARDS_AUTHENTICATED_PAGE = `${TREATS_REWARDS_PAGE}/authenticated`;

export const CREATE_ACCOUNT_PAGE = '/create-account';

export const SIGN_IN_PAGE = '/sign-in';

export const ACTIVATE_OFFER_PAGE = '/activate-offer';

export const RESET_PASSWORD = '/reset-password';
